import { useBasicABTest } from '@bridebook/web/app-basic/lib/ab-tests/hooks/use-basic-ab-test';

export const hideLimitedProfilesTestId = 'LIVE-27960_HideLimitedProfiles';

/**
 * Hook for initializing the test
 */
export const useABTest_HideLimitedProfiles = () => useBasicABTest(hideLimitedProfilesTestId);
